import React from "react";
import PlaylistCard from "./PlaylistCard";

const PlaylistsList = ({ playlists }) => {

    return (
        <>
            <div className="row">
                {playlists?.map((playlist) => {
                    return (
                        <React.Fragment key={playlist.id}>
                            <PlaylistCard
                                playlist={playlist}
                            />
                        </React.Fragment>
                    );
                })}
            </div>
        </>
    );
};

export default PlaylistsList;